import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

import { colors } from "../../../../components/theme";

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    fontSize: "12px",
    fontWeight: "lighter",
  },
}));

export const WrapperCheckBox = styled.div`
  width: 100%;
  padding: 20px;
  overflow: hidden;
  border-radius: 4px;
  display: inline-block;
  background-color: white;
`;
export const Title = styled.h4`
  color: #0076ff;
  margin: 0 auto;
  text-align: left;
  font-weight: 900;
  position: absolute;
`;
export const Container = styled.div`
  width: 100%;
  background-color: ${colors.white};
  position: relative;
  height: auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonContainerTools = styled.div`
  display: flex;
  width: 100%;
  margin-top: 10px;
  height: 23px;
  justify-content: space-between;
`;

export const CheckContainerTools = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  gap: 10px;
`;

export const ContainerTextField = styled.div`
  width: 100%;
`;

export const DivHelperTextTitle = styled.div`
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 12px;
`;
